import type { ThemeObject } from "@circle-react/types/Theme";
import type { ReactNode } from "react";

import { ThemeProvider } from "../Theme";
import { useCommunityTheme } from "../Theme/useCommunityTheme";

interface CommunityThemeProviderProps {
  children: ReactNode;
  fallbackTheme: ThemeObject;
}

export const CommunityThemeProvider = ({
  children,
  fallbackTheme,
}: CommunityThemeProviderProps) => {
  const theme = useCommunityTheme(fallbackTheme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
